module.exports = __webpack_public_path__ + "assets/germany.fbf481211eb1ef215d7a0df9ca7579ce.svg?";